import React from 'react';
import { SPageCnt } from './styles';

export const PageCnt = ({ children }) => {
  return <SPageCnt>{children}</SPageCnt>;
};
